module.exports = __webpack_public_path__ + "static/media/jest-as-platform.1cf1cb2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/expect-more/assets/jest-as-platform.png
// module id = 672
// module chunks = 0